import { render, staticRenderFns } from "./SearchItemsResult.vue?vue&type=template&id=b9d67ab8&"
import script from "./SearchItemsResult.vue?vue&type=script&lang=js&"
export * from "./SearchItemsResult.vue?vue&type=script&lang=js&"
import style0 from "./SearchItemsResult.vue?vue&type=style&index=0&id=b9d67ab8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports